const abTests = {
  homeProofWidget: 'home:proofWidget',
  homeSpanishMen: 'home:spanishMen',
  homeSpanishWomen: 'home:spanishWomen',
  homeHumbleTeam: 'home:mobile:humbleTeam',

  humbleTeamQuiz: 'landing:humbleTeamQuiz',
  priceTestMobile: 'landing:priceTestMobile',

  facebookFreeTrial: 'facebook:freeTrial',
  facebookOfferDiscount: 'facebook:offerDiscount',

  emptyQueue: 'main:emptyQueue',

  unsubscribeProlonged: 'profile:unsubscribeProlonged',
  unsubscribeOfferTest: 'unsubscribe:offerTest',

  productQuiz: 'product:quiz',
  productExpertReviews: 'product:expertReviews',

  makeupNewLandingStyle: 'makeupIntro:newLandingStyle',

  newRegisterFlow: 'register:newFlow',

  menuDesktopDropdown: 'menu:desktopDropdown',

  addToQueueModals: 'modals:addToQueue',

  algoliaSearch: 'search:algolia',

  coTrafficSplitTest: 'coTrafficSplitTest',

  newCancelFlow: 'unsubscribe:firstMonth',

  resubscribeProductPage: 'resubscribe:productPage',
  resubscribeBurgerMenu: 'resubscribe:burgerMenu',

  welcomeFlow: 'flow:welcome',

  prefetchingAssets: 'landings:prefetchingAssets',
  freeTrial7Vs50Off: 'landings:freeTrial7Vs50Off',

  addToQueueWidget: 'addToQueueWidget',

  recsNewQuiz: 'recs:newQuiz',

  mainStory: 'main:story',

  piio: 'site:piio',

  mainPromoteSections: 'main:promoteSections',

  newMobileThankYouPage: 'thankYou:mobile:new',
  newMobileThankYouPage2: 'thankYou:mobile:new2',
  inviteFriendThankYouPage: 'thankYou:inviteFriend',

  subscriptionDesktopHumbleSubFlow: 'subscription:desktop:humbleSubFlow',
  subscriptionDesktop3: 'subscription:desktop:v.3.0',

  caseSubscriptionFlow: 'site:caseSubscriptionFlow',
  caseSubscriptionFlowDesktop: 'site:caseSubscriptionFlowDesktop',

  queueOrderCOGS: 'site:queueOrderCOGS',

  newInvitePage: 'site:newInvitePage',
  newInvitePageDesktop: 'site:newInvitePageDesktop',

  mobileNavigation: 'site:mobileNavigation',

  tariffsOnMainPage: 'landing:tariffsOnMainPage',
  bannerOnMainPage: 'landing:bannerOnMainPage',
  referralLanding: 'landing:referral',
  landingBurgerMenu: 'landing:burgerMenu',

  upgradeSimplePage: 'upgrade:simplePage',

  newPaymentFlow: 'site:newPaymentFlow',

  twoItemsOnCo: 'landing:twoItemsOnCo',

  newRegistrationView: 'site:registration2.0',

  mainRestyle: 'main:restyle',

  mainDesktopFirstScreen: 'landing:mainDesktopFirstScreen',

  acquisitionQuiz: 'site:acquisitionQuiz',
  pickPagePerfumeRating: 'site:pickPagePerfumeRating',

  blueTriangle: 'blueTriangle', // INT-34
  tossInCartSubtotal: 'tossInCartSubtotal',
}

export default abTests
